var _class;
import { Component } from "react";
import { withTranslation } from "react-i18next";
import Styles from "./mappable-preview.scss";
import { observer } from "mobx-react";
import isDefined from "../../Core/isDefined";
import ExportableMixin from "../../ModelMixins/ExportableMixin";
import FileSaver from "file-saver";
import { jsx as _jsx } from "react/jsx-runtime";
export async function exportData(item) {
  const data = await item.exportData();
  if (!isDefined(data)) {
    return;
  }
  if (typeof data === "string") {
    window.open(data);
  } else if ("file" in data && "name" in data) {
    FileSaver.saveAs(data.file, data.name);
  }
}

/**
 * CatalogItem ExportData.
 */
let ExportData = observer(_class = class ExportData extends Component {
  exportDataClicked(item) {
    exportData(item).catch(e => {
      this.props.item.terria.raiseErrorToUser(e);
    });
  }
  render() {
    const catalogItem = this.props.item;
    if (!catalogItem || !ExportableMixin.isMixedInto(catalogItem) || !catalogItem.canExportData) return null;
    return /*#__PURE__*/_jsx("div", {
      className: Styles.metadata,
      children: /*#__PURE__*/_jsx("button", {
        onClick: this.exportDataClicked.bind(this, catalogItem),
        children: "Export data"
      })
    });
  }
}) || _class;
export default withTranslation()(ExportData);